import { Fragment, useCallback } from 'react';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { rotatePages } from 'app/store/pagesToolbar/pagesToolbar.async';
// Actions
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectSelectedPageIds } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Icons
import {
  ArrowDropDown as ArrowDropDownIcon
} from '@mui/icons-material';
// Hooks
import useMenu from 'app/hooks/useMenu';
// Components
import Icon from 'app/components/Icon';
import { IconButton } from 'app/components/Mui';
// Utils
import usePagesUtilities from '../utils/usePagesUtilities';

const RotateDropdown = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const selectedPageIds = useAppSelector(selectSelectedPageIds);

  const { getPagesByIds, updatePagesRotation } = usePagesUtilities();
  const { Menu, MenuItem, openMenu } = useMenu();

  const handleRotationClick = useCallback((degrees:number) => async () => {
    const pages = getPagesByIds(selectedPageIds, true);
    const updatedPages = updatePagesRotation(pages, degrees);

    if ( !updatedPages.length ) return;

    dispatch(PagesToolbarActions.setLoadingPages(selectedPageIds));

    await dispatch(rotatePages(updatedPages)).unwrap();

    dispatch(MixpanelActions.handleCasePagesBulkActionClick({ action: 'rotate', numberOfPages: updatedPages.length }));
  }, [dispatch, selectedPageIds, getPagesByIds, updatePagesRotation]);

  return (
    <Fragment>
      <IconButton
        name="Rotate dropdown"
        aria-label="Team item dropdown button"
        onClick={openMenu}
      >
        <Icon icon="rotate_right_outlined" />
        <ArrowDropDownIcon fontSize="small" />
      </IconButton>
      <Menu>
        <MenuItem
          name="Rotate right 90"
          sx={{ gap: 2 }}
          onClick={handleRotationClick(90)}
        >
          <Icon icon="rotate_clockwise_90" />
          Rotate right 90
        </MenuItem>
        <MenuItem
          name="Rotate right 180"
          sx={{ gap: 2 }}
          onClick={handleRotationClick(180)}
        >
          <Icon icon="rotate_clockwise_180" />
          Rotate right 180
        </MenuItem>
        <MenuItem
          name="Rotate right 270"
          sx={{ gap: 2 }}
          onClick={handleRotationClick(270)}
        >
          <Icon icon="rotate_clockwise_270" />
          Rotate right 270
        </MenuItem>
      </Menu>
    </Fragment>
  )
}

export default RotateDropdown;
